<template>
	<el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" title="绑定微信号" :visible.sync="dialogVisible" destroy-on-close width="800px">
		<div class="qrcode-container">
			<div v-if="!wechatQrCodeUrl" class="qrcode-loading">
				<i class="el-icon-loading loading-icon"></i>
				<p>正在加载二维码...</p>
			</div>
			<div class="qrcode-content" v-else>
				<div class="qrcode-wrapper" id="qrcode-wrapper">
					<iframe :src="wechatQrCodeUrl" frameborder="0" class="qrcode-img"></iframe>
				</div>
				<p class="qrcode-tips">请使用微信扫描二维码绑定微信号</p>
			</div>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="handleClose">关闭</el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script>
import TMessage from '@/utils/TMessage';
import { getMemberLoginUrl } from '@/api/user/login';
import { mapGetters, mapActions } from 'vuex';
export default {
	name: 'DialogEditWechat',
	data() {
		return {
			// dialogVisible: false,
			wechatQrCodeUrl: ''
		};
	},
	computed: {
		dialogVisible() {
			return this.$store.getters['Settings/sWechatBindShow'];
		}
	},

	mounted() {
		window.addEventListener('message', this.handleMessage);
	},

	beforeDestroy() {
		window.removeEventListener('message', this.handleMessage);
	},

	watch: {
		dialogVisible: {
			handler(newVal) {
				if (newVal) {
					this.$nextTick(() => {
						this.initWechatBind();
					});
				}
			},
			immediate: true
		}
	},
	methods: {
		...mapActions('Settings', ['setWechatBindShow']),
		...mapActions('User', ['getUserInfo']),

		handleMessage(event) {
			// 验证消息格式
			if (!event.data || typeof event.data !== 'object') {
				return;
			}

			if (event.data.type == 'wechatBindSuccess') {
				this.setWechatBindShow(false);
				TMessage.success('微信绑定成功');
				this.getUserInfo();
			}
			if (event.data.type == 'wechatBindFail') {
				this.$nextTick(() => {
					this.initWechatBind();
				});
				//code == 40021  表示该微信号被占用
				if (event.data.code == '40021') {
					TMessage.error('微信已被绑定，请合并账户。');
					//关闭当前框
					this.handleClose();
					this.$emit('mergeAccount');
					// 合并账户
					// TMessage.warning('该微信号已被占用');
				} else {
					TMessage.error(event.data.msg);
				}
			}
		},

		handleClose() {
			this.setWechatBindShow(false);
		},

		async initWechatBind() {
			try {
				let res = await getMemberLoginUrl('bind_' + Math.random().toString());
				if (res && res.data) {
					this.wechatQrCodeUrl = res.data;
				}
			} catch (error) {
				console.error('初始化微信登录失败:', error);
				TMessage.error('微信登录初始化失败');
			}
		}
	}
};
</script>

<style lang="less" scoped>
.qrcode-container {
	margin-bottom: 25px;
	text-align: center;

	.qrcode-loading {
		padding: 40px;
		color: #94a3b8;

		.loading-icon {
			font-size: 40px;
			margin-bottom: 15px;
			color: #155dfc;
			animation: spin 1s linear infinite;
		}

		p {
			font-size: 14px;
			margin: 0;
		}

		@keyframes spin {
			0% {
				transform: rotate(0deg);
			}
			100% {
				transform: rotate(360deg);
			}
		}
	}

	.qrcode-content {
		.qrcode-wrapper {
			padding: 15px;
			background: white;
			border-radius: 12px;
			// border: 1px solid #e2e8f0;
			display: inline-block;
			// box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		}

		.qrcode-img {
			// width: 180px;
			// height: 180px;
			// width: 360px;
			height: 164px;
			display: block;
		}

		.qrcode-tips {
			margin-top: 20px;
			color: #475569;
			font-size: 14px;
			line-height: 1.5;
		}
	}
}
// 弹出框重置样式
/deep/ .el-dialog__header {
	border-bottom: 1px dashed #e2e8f0;
	margin-right: 0;
	background: #f8fafc;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
	color: #3a434f;
	font-size: 24px;
}

/deep/ .el-dialog__footer {
	border-top: 1px solid #e8e8e8;
	padding: 18px;
}

/deep/ .el-dialog__body .el-form-item__label {
	line-height: 26px;
}
</style>
